import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let calendar_date_user = new BaseTableModule('/ws/calendar_date_user/');

const state = {
    ...calendar_date_user.state,
    columns: [
        {text: 'Start week date', value: 'calendar_date__start_week_date', sortable: false, filterable: true, divider: true, brief: true, width: 150},
        {text: 'Human user', value: 'human_user__user', sortable: false, filterable: true, divider: true, brief: true, width: 200},
        {text: 'Work', value: 'work_sum', sortable: false, filterable: true, divider: true, brief: true, width:50},
        {text: 'Work tracker', value: 'work_tracker_sum', sortable: false, filterable: true, divider: true, brief: true, width:50},
        {text: 'Plan', value: 'plan_sum', sortable: false, filterable: true, divider: true, brief: true, width:50},
        {text: 'Up work', value: 'up_work_sum', sortable: false, filterable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['-id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
    local_phrase: {
        tracker: {en: 'tracker', de: 'Tracker', color: 'blue darken-1', class: 'timer'},
        working: {en: 'working', de: 'Arbeit', color: 'blue darken-1', class: 'more_time'},
        work_kug: {en: 'work_kug', de: 'KUG', color: 'deep-purple darken-1', class: 'access_time'},
        pause: {en: 'pause', de: 'Zeitkorrektur', color: 'light-blue darken-1', class: 'pause_circle'},
        time_correction: {en: 'time correction', de: 'Zeitabzug', color: 'brown darken-1', class: 'timer_off'},
        time_add: {en: 'time add', de: 'Zeit-Plus', color: 'light-blue darken-1', class: 'add_alarm'},
        holiday: {en: 'holiday', de: 'Urlaub', color: 'green darken-1', class: 'beach_access'},
        holiday_extra: {en: 'holiday extra', de: 'Überstunden', color: 'green darken-1', class: 'home'},
        sick: {en: 'sick', de: 'Krank', color: 'amber darken-1', class: 'sick'},
        sick_with_child: {en: 'sick with child', de: 'Kind krank', color: 'amber darken-1', class: 'child_care'},
        sick_kug: {en: 'sick kug', de: 'KUG-Krank', color: 'orange darken-1', class: 'healing'},
    },

};
const getters = {
    ...calendar_date_user.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...calendar_date_user.actions,
};
const mutations = {
    ...calendar_date_user.mutations,
};

export default {
    modules: {
        CalendarDateUserWeek: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}